import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const SEND_FIDUCIARY_REPORT_BY_MAIL = gql`
  mutation SendFiduciaryReportByMail($expenseReportsUuids: [ID!]!) {
    sendFiduciaryReportByMail(expenseReportsUuids: $expenseReportsUuids)
  }
`;

export function useSendFiduciaryReportByMail() {
  const [sendFiduciaryReportByMailMutation, { loading, error, data }] = useMutation(SEND_FIDUCIARY_REPORT_BY_MAIL);

  // Fonction pour passer les UUIDs directement
  const sendFiduciaryReportByMail = async (expenseReportsUuids) => {
    const result = await sendFiduciaryReportByMailMutation({
      variables: { expenseReportsUuids },
    });
    return result?.data?.sendFiduciaryReportByMail;
  };

  return { sendFiduciaryReportByMail, loading, error, data };
}
